// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WalletView {
  padding-block: 3rem;
}
.WalletView .WalletView--filter-btn {
  display: flex;
  justify-content: space-between;
}
.WalletView .WalletView--filter-btn h1 {
  font-size: 18px;
  font-weight: 600;
}
.WalletView .WalletView--transaction-history {
  padding-block: 1rem;
  margin-bottom: 8rem;
}
.WalletView .WalletView--transaction-group {
  margin-bottom: 1.5rem;
}
.WalletView .WalletView--transaction-group-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 0.75rem;
}

.chatBotIcon {
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 64px;
  height: 64px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;
}

.WalletView--InvoicePolling {
  text-align: center;
  padding: 20px;
  display: grid;
  place-items: center;
  font-size: 1.4rem;
}
.WalletView--InvoicePolling .loading-text {
  margin-top: 10px;
}
.WalletView--InvoicePolling .cancel-btn {
  margin-top: 15px;
  font-size: 1.2rem;
  color: #00aa74;
  cursor: pointer;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/Views/AfterAuth/WalletView/WalletView.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;AACI;EACI,aAAA;EACA,8BAAA;AACR;AACQ;EACI,eAAA;EACA,gBAAA;AACZ;AAGI;EACI,mBAAA;EACA,mBAAA;AADR;AAII;EACI,qBAAA;AAFR;AAKI;EACI,eAAA;EACA,gBAAA;EAEA,sBAAA;AAJR;;AAQA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;AALJ;;AAQA;EACI,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AALJ;AAOI;EACI,gBAAA;AALR;AAQI;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;AANR","sourcesContent":[".WalletView {\n    padding-block: 3rem;\n\n    .WalletView--filter-btn {\n        display: flex;\n        justify-content: space-between;\n\n        h1 {\n            font-size: 18px;\n            font-weight: 600;\n        }\n    }\n\n    .WalletView--transaction-history {\n        padding-block: 1rem;\n        margin-bottom: 8rem;\n    }\n\n    .WalletView--transaction-group {\n        margin-bottom: 1.5rem;\n    }\n\n    .WalletView--transaction-group-title {\n        font-size: 16px;\n        font-weight: 700;\n        // color: $color_black_400;\n        margin-bottom: 0.75rem;\n    }\n}\n\n.chatBotIcon {\n    position: fixed;\n    bottom: 80px;\n    right: 20px;\n    width: 64px;\n    height: 64px;\n    background: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    z-index: 1000;\n}\n\n.WalletView--InvoicePolling {\n    text-align: center;\n    padding: 20px;\n    display: grid;\n    place-items: center;\n    font-size: 1.4rem;\n\n    .loading-text {\n        margin-top: 10px;\n    }\n\n    .cancel-btn {\n        margin-top: 15px;\n        font-size: 1.2rem;\n        color: #00aa74;\n        cursor: pointer;\n        text-decoration: underline;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
